import React from 'react'

export default function IncomingCallSound({ ringingPlay }) {

    return (
        ringingPlay.data && <audio autoPlay loop src={'/audio/xylophone.mp3'} />
    );

}
